import { render, staticRenderFns } from "./Participations.vue?vue&type=template&id=379a9545&"
import script from "./Participations.vue?vue&type=script&lang=js&"
export * from "./Participations.vue?vue&type=script&lang=js&"
import style0 from "./Participations.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports